import type { GroupLevel } from "@ext/catalog/views/logic/utils/putArticleIntoGroup";
import type { PropertyID, PropertyValue } from "@ext/properties/models";

const applyGroupLevels = (
	properties: PropertyValue[],
	levels: GroupLevel[],
	isMany: (id: PropertyID) => boolean,
): PropertyValue[] =>
	levels.reduce((current, level) => {
		const others = current.filter((property) => property.id !== level.id);
		const currentValues = current.find((property) => property.id === level.id)?.value ?? [];
		const kept = isMany(level.id) ? currentValues.filter((value) => value !== level.from) : [];
		const next = level.to && !kept.includes(level.to) ? [...kept, level.to] : kept;

		return next.length ? [...others, { id: level.id, value: next }] : others;
	}, properties ?? []);

export default applyGroupLevels;
